module.exports = "/_next/static/images/c413736fef446d0400e29652b7bdfbd2-rewards-partners@3x.jpg.webp";